import React, { useState } from "react";
import Image from "next/image";
import { FormHeading, SuccessMessageType } from "@/interface/types";
import GlobalForm from "@/components/forms/GlobalForm";
import useModalScrollLock from "@/hooks/useModalScrollLock";

const RoadmapDesktop: React.FC = () => {
  const [isFormModelOpen, setIsFormModelOpen] = useState<boolean>(false);

  const handleFormModelOpen = () => {
    setIsFormModelOpen(true);
  };

  const handleFormModelClose = () => {
    setIsFormModelOpen(false);
  };

  useModalScrollLock(isFormModelOpen, {
    restoreScrollPosition: true,
    preventTouchScroll: true,
  });

  return (
    <>
      <div className="w-full bg-[#061A2F] relative bg-cover bg-no-repeat overflow-hidden">
        <div className="container relative w-full flex justify-center items-center mt-0 md:mb-10 2xl:mb-14">
          <Image
            src="/cpa/roadmapDesktop.png"
            alt="alt"
            className="w-[100%]"
            width={1160}
            height={419}
          />

          <div className="grp_btn flex flex-col items-center justify-center mt-5   ">
            <div className="flex absolute py-2 2xl:left-[6.40%] 2xl:bottom-[22.60%]  md:left-[6.40%] md:bottom-[22.80%]">
              <p className="text-[#000] text-[20px] font-semibold ">
                Mar 28 | Saturday | 3 PM IST{" "}
              </p>
            </div>
            <div className="flex absolute 2xl:left-[6.50%] 2xl:bottom-[11%] md:left-[6.50%] md:bottom-[14%] cursor-pointer">
              <Image
                priority
                src="/arrow_new.png"
                alt="arrow image"
                className="new_arrow md:w-[35px] 2xl:w-[45px]"
                width={45}
                height={45}
              />
              <p
                className="new__discover_btn font-medium !bg-[#316BC9] !rounded-[27px_27px_27px_0px]  inline-block md:py-[6px] 2xl:py-[9px] md:px-[20px] 2xl:px-[30px] md:text-[14px] 2xl:text-base"
                onClick={handleFormModelOpen}
              >
                Join Live Webinar
              </p>
            </div>
          </div>
        </div>
      </div>

      {isFormModelOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-[999] lg:p-10 p-4">
          <div
            className="rounded-2xl shadow-lg relative h-[auto] mx-auto border border-white p-4 w-[400px]"
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(51, 153, 255, 0.30) 100%)",
              boxShadow: "0px 0px 14px 0px rgba(4, 84, 175, 0.29)",
              backdropFilter: "blur(28px)",
            }}
          >
            <button
              onClick={handleFormModelClose}
              className="text-white text-lg absolute right-4 top-3 cursor-pointer"
            >
              ✕
            </button>
            <div className="pt-4">
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/starGroup.webp"
                alt="star group"
                width={34}
                height={38}
                className="absolute top-6 left-[-10px]"
              />
              <GlobalForm
                course="live webinar"
                courseId={3}
                formHeading={
                  FormHeading.JOIN_THE_WEBINAR_AND_MAKE_THE_BIG_DECISION
                }
                formType="model"
                submitButtonName="Register Now"
                successMessage={SuccessMessageType.LIVE_WEBINAR}
                darkBackground={true}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RoadmapDesktop;
